import React from 'react';

import { useIntl } from '@edx/frontend-platform/i18n';

import SidebarBase from '../../common/SidebarBase';
import messages from '../../messages';
import DiscussionsSidebar from './discussions/DiscussionsWidget';
import { ID } from './DiscussionsNotificationsTrigger';

const DiscussionsNotificationsSidebar = () => {
  const intl = useIntl();

  return (
    <SidebarBase
      ariaLabel={intl.formatMessage(messages.discussionNotificationTray)}
      sidebarId={ID}
      className="d-flex flex-column flex-fill overflow-auto"
      showTitleBar={false}
      showBorder={false}
    >
      <DiscussionsSidebar />
    </SidebarBase>
  );
};

export default DiscussionsNotificationsSidebar;
